export default __webpack_public_path__ + "static/media/gmx-logo-final-white.b7833ed6.png";